import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useToolbarState } from '../../contexts/ToolbarContext';
import styles from '../../styles/components/InlineToolbarSlot.module.scss';

// ============================================================================
// Анимации
// ============================================================================

const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2 },
};

// ============================================================================
// Компонент
// ============================================================================

/**
 * Компактная inline-строка с Reload + Filters + Additional controls.
 * Используется на страницах без SubHeaderStages (References, Demo и т.д.).
 * Без glass-стиля — минимальный визуальный вес.
 */
const InlineToolbarSlotInner: React.FC = () => {
  const toolbar = useToolbarState();

  const hasContent = !!(toolbar.filters || toolbar.additionalControls);
  if (!hasContent) return null;

  return (
    <AnimatePresence>
      <motion.div className={styles.inlineToolbar} {...fadeIn}>
        {toolbar.additionalControls && (
          <div className={styles.section}>
            {toolbar.additionalControls}
          </div>
        )}

        {toolbar.filters && (
          <div className={styles.section}>
            {toolbar.filters}
          </div>
        )}
      </motion.div>
    </AnimatePresence>
  );
};

export const InlineToolbarSlot = React.memo(InlineToolbarSlotInner);
